import { render, staticRenderFns } from "./editBenefitType.vue?vue&type=template&id=68cacc72&"
import script from "./editBenefitType.vue?vue&type=script&lang=js&"
export * from "./editBenefitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports